<template>
    <section>
        <el-button class="my-2 p-2 w-100 sign-button" @click="$bus.$emit('openPad')" type="warning">CLICK TO SIGN</el-button>
        <signature-modal
            :title="false"
            :applicant="applicant"
            :open.sync="open"
            :verification-signature="false"
            :contract-signature="null"
            timeline-url="null"
            :save-signature-url="saveSignatureUrl"
            :submit-url="submitUrl"
        ></signature-modal>
    </section>
</template>

<script>
import SignatureModal from "@frontend/components/SignatureModal";
export default {
  name: 'ConditionSignOff',
  components: {
    SignatureModal
  },
  props: {
      buttonTitle: {
          default: 'GET MY APPROVAL'
      },
      applicant: {
        required: true
      },
      saveSignatureUrl: {
          required:false,
      },
      submitUrl: {
          required: false
      }
  },
  data() {
    return {
        open: false,
        signature: null,
    }
  },
  computed: {
  },
  watch: {
  },
  mounted() {
    this.$bus.$on('openPad', this.openPad);
  },
  updated() {
  },
  activated() {
  },
  methods: {
    openPad(signature) {
      this.signature = signature;
      this.open = true;
    },
  },
  beforeDestroy() {
    this.$bus.$off("openPad");
  },
}
</script>

<style lang="scss" scoped>
    .sign-button {
        padding: 1.3rem!important;
        font-size: 1.2rem;
        font-weight: 600;
    }
// @import '@assets/sass/backend/_core-variables.scss';
</style>
